import React, { useEffect, useState, useRef } from "react";
import {
  HeaderContainer,
  HeaderLogoImg,
  HeaderLinkContainer,
  HeaderLink,
  MobileMenuButton,
  LogoContainer,
  HeaderLogoImgContainer,
  SecondHeaderContainer,
} from "./styles";
import HubReserveLogo from "../../assets/hub-reserve-white.png";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import theme from "../../theme/theme";
import {
  AccountCircle,
  BarChart,
  Groups,
  History,
  Logout,
  AccountBox,
  InsertChart,
  AddModerator,
  CalendarMonth,
  Grade,
  BookmarkAdd,
  Bookmarks,
  ExpandLess,
  ExpandMore,
  Person,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { ROUTES } from "../../routes/constants";
import { HeaderProps } from "./types";
import { postLogout } from "../../services/user/postActions";
import Avatar from "@mui/material/Avatar";
import { getUserById } from "../../services/user/getUser";
import { getProfilePicture } from "../../services/user/getProfilePicture";

const ProfileDropdown: React.FC<{
  isAdmin: boolean;
  isOpen: boolean;
  onClose: () => void;
}> = ({ isAdmin, isOpen, onClose }) => {
  const navigate = useNavigate();
  const { addToast } = useToasts();
  const jwt = localStorage.getItem("jwt");
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const handleClickAway = (event: MouseEvent) => {
    // Verifica si el clic se realizó fuera del dropdown
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      onClose(); // Cierra el dropdown
    }
  };

  const handleLogout = async () => {
    await postLogout(jwt!)
      .then((res) => {
        if (res.status < 300) {
          // Borra los datos del localStorage
          localStorage.removeItem("jwt");
          localStorage.removeItem("user_type");
          localStorage.removeItem("user_id");
          localStorage.removeItem("view");

          // Luego, redirige al usuario a la página de inicio de sesión
          navigate(`${ROUTES.LOGIN}`);
          addToast("Vuelva pronto", {
            appearance: "success",
            autoDismiss: true,
          });
        } else {
          addToast("Ocurrió un error", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      })
      .catch((err) => {
        addToast("Ocurrió un error", {
          appearance: "error",
          autoDismiss: true,
        });
      });
  };

  useEffect(() => {
    // Agrega el event listener para cerrar el dropdown al hacer clic fuera de él
    document.addEventListener("mousedown", handleClickAway);

    return () => {
      // Remueve el event listener al desmontar el componente
      document.removeEventListener("mousedown", handleClickAway);
    };
  }, [onClose]);

  return (
    <div
      ref={dropdownRef}
      style={{
        position: "absolute",
        top: "60px", // Ajusta la posición vertical según tu diseño
        right: "75px",
        zIndex: 100002,
        width: "auto",
        borderRadius: "10px",
        backgroundColor: theme.color.white,
        boxShadow: `0px 4px 4px 0px rgba(0, 0, 0, 0.25)`,
      }}
    >
      <List sx={{ width: "225px" }}>
        <ListItem
          disablePadding
          sx={{ borderBottom: "1px solid rgba(255, 255, 255, 0.2)" }}
        >
          <ListItemButton
            sx={{
              "&:hover": {
                color: theme.color.honey,
                transition: "color 0.3s ease-in-out",
                svg: {
                  color: theme.color.honey,
                  transition: "color 0.3s ease-in-out",
                },
              },
            }}
            onClick={() => {
              isAdmin
                ? navigate(`${ROUTES.ADMIN}${ROUTES.PROFILE}`)
                : navigate(`${ROUTES.PROFILE}`);
            }}
          >
            <ListItemIcon>
              <AccountCircle
                sx={{ color: theme.color.black, paddingLeft: "10px" }}
              />
            </ListItemIcon>
            <ListItemText primary="Mi perfil" />
          </ListItemButton>
        </ListItem>

        {!isAdmin ? (
          <ListItem
            disablePadding
            sx={{ borderBottom: "1px solid rgba(255, 255, 255, 0.2)" }}
          >
            <ListItemButton
              sx={{
                "&:hover": {
                  color: theme.color.honey,
                  transition: "color 0.3s ease-in-out",
                  svg: {
                    color: theme.color.honey,
                    transition: "color 0.3s ease-in-out",
                  },
                },
              }}
              onClick={() => navigate(`${ROUTES.STATISTICS}`)}
            >
              <ListItemIcon>
                <BarChart
                  sx={{ color: theme.color.black, paddingLeft: "10px" }}
                />
              </ListItemIcon>
              <ListItemText primary="Mis estadísticas" />
            </ListItemButton>
          </ListItem>
        ) : (
          <></>
        )}

        {!isAdmin ? (
          <ListItem
            disablePadding
            sx={{ borderBottom: "1px solid rgba(255, 255, 255, 0.2)" }}
          >
            <ListItemButton
              sx={{
                "&:hover": {
                  color: theme.color.honey,
                  transition: "color 0.3s ease-in-out",
                  svg: {
                    color: theme.color.honey,
                    transition: "color 0.3s ease-in-out",
                  },
                },
              }}
              onClick={() => navigate(`${ROUTES.HISTORY}`)}
            >
              <ListItemIcon>
                <History
                  sx={{ color: theme.color.black, paddingLeft: "10px" }}
                />
              </ListItemIcon>
              <ListItemText primary="Historial" />
            </ListItemButton>
          </ListItem>
        ) : (
          <> </>
        )}

        <ListItem
          disablePadding
          sx={{ borderBottom: "1px solid rgba(255, 255, 255, 0.2)" }}
        >
          <ListItemButton
            sx={{
              "&:hover": {
                color: theme.color.ruby,
                transition: "color 0.3s ease-in-out",
                svg: {
                  color: theme.color.ruby,
                  transition: "color 0.3s ease-in-out",
                },
              },
            }}
            onClick={handleLogout}
          >
            <ListItemIcon>
              <Logout sx={{ color: theme.color.black, paddingLeft: "10px" }} />
            </ListItemIcon>
            <ListItemText primary="Cerrar sesión" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );
};

const Header: React.FC<HeaderProps> = ({ variant = "" }) => {
  const { addToast } = useToasts();
  const jwt = localStorage.getItem("jwt");
  const userId = localStorage.getItem("user_id");

  const [userName, setUserName] = React.useState("");
  const [serverResponse, setServerResponse] = React.useState(false); // Server response state
  const [selectedImage, setSelectedImage] = useState<string | undefined>(
    undefined
  );

  // ------------------- API REQUEST -------------------
  const getUser = async () => {
    if (userId) {
      await getUserById(parseInt(userId), jwt!)
        .then((res: any) => {
          if (res && res.data) {
            setUserName(res.data.user.name);
          }
        })
        .catch((err: any) => {
          console.log(err, "err");
        });
    }
  };

  const getPicture = async () => {
    await getProfilePicture(jwt!)
      .then((res) => {
        if (res.status !== 200) {
          setServerResponse(false);
        } else {
          setServerResponse(true);
          setSelectedImage(res.data.url);
        }
      })
      .catch((err) => { });
  };

  const handleLogout = async () => {
    await postLogout(jwt!)
      .then((res) => {
        if (res.status < 300) {
          // Borra los datos del localStorage
          localStorage.removeItem("jwt");
          localStorage.removeItem("user_type");
          localStorage.removeItem("user_id");
          localStorage.removeItem("view");
          setOpen(false);

          // Luego, redirige al usuario a la página de inicio de sesión
          navigate(`${ROUTES.LOGIN}`);
          addToast("Vuelva pronto", {
            appearance: "success",
            autoDismiss: true,
          });
        } else {
          addToast("Ocurrió un error", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      })
      .catch((err) => {
        addToast("Ocurrió un error", {
          appearance: "error",
          autoDismiss: true,
        });
      });
  };

  const items =
    variant === "admin"
      ? [
        // Admin variant items
        {
          text: "Panel",
          icon: <AddModerator sx={{ color: theme.color.white }} />,
          path: `${ROUTES.ADMIN}${ROUTES.PANEL}`,
        },
        {
          text: "Reservaciones",
          icon: <Bookmarks sx={{ color: theme.color.white }} />,
          path: `${ROUTES.ADMIN}${ROUTES.ADMIN_RESERVATIONS}`,
        },
        {
          text: "Estadísticas",
          icon: <InsertChart sx={{ color: theme.color.white }} />,
          path: `${ROUTES.ADMIN}${ROUTES.STATISTICS}`,
        },
        {
          text: "Usuarios",
          icon: <Groups sx={{ color: theme.color.white }} />,
          path: `${ROUTES.ADMIN}${ROUTES.USERS}`,
        },
        {
          text: "Mi Perfil",
          icon: <AccountBox sx={{ color: theme.color.white }} />,
          path: `${ROUTES.ADMIN}${ROUTES.PROFILE}`,
        },
      ]
      : [
        // Default variant items
        {
          text: "Reservar",
          icon: <BookmarkAdd sx={{ color: theme.color.white }} />,
          path: `${ROUTES.RESERVE}`,
        },
        {
          text: "Favoritos",
          icon: <Grade sx={{ color: theme.color.white }} />,
          path: `${ROUTES.FAVORITES}`,
        },
        {
          text: "Calendario",
          icon: <CalendarMonth sx={{ color: theme.color.white }} />,
          path: `${ROUTES.CALENDAR}`,
        },
        {
          text: "Mis Reservaciones",
          icon: <Bookmarks sx={{ color: theme.color.white }} />,
          path: `${ROUTES.RESERVATIONS}`,
        },
      ];

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false); // Nuevo estado para el dropdown de perfil
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
    setOpen(false);
  };

  const handleProfileDropdownToggle = () => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
  };

  useEffect(() => {
    // Siempre que cambie la ubicación, desplázate al inicio de la página
    window.scrollTo(0, 0);

    // Cierra el dropdown cuando cambia la ubicación
    setIsProfileDropdownOpen(false);
  }, [location]);

  React.useEffect(() => {
    getUser();
    getPicture();
  }, []);

  React.useEffect(() => {
    getUser();
  }, [userName]);

  const list = () => {
    const handleButtonClick = (path: any) => {
      navigate(path);
      handleDrawerToggle();
      setOpen(false);
    };

    return (
      <Box sx={{ width: 250 }} role="presentation">
        <List>
          {items.map(({ text, icon, path }, index) => (
            <ListItem
              key={text}
              disablePadding
              sx={{
                borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                paddingLeft: "10px",
              }}
            >
              <ListItemButton
                sx={{
                  "&:hover": {
                    color: theme.color.honey,
                    transition: "color 0.3s ease-in-out",
                    svg: {
                      color: theme.color.honey,
                      transition: "color 0.3s ease-in-out",
                    },
                  },
                }}
                onClick={() => handleButtonClick(path)}
              >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}

          <ListItem
            key="Perfil"
            disablePadding
            sx={{
              borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
              paddingLeft: "10px",
            }}
          >
            <ListItemButton
              sx={{
                "&:hover": {
                  color: theme.color.honey,
                  transition: "color 0.3s ease-in-out",
                  svg: {
                    color: theme.color.honey,
                    transition: "color 0.3s ease-in-out",
                  },
                },
              }}
              onClick={() => handleClick()}
            >
              <ListItemIcon>
                <Person sx={{ color: theme.color.white }} />
              </ListItemIcon>
              <ListItemText primary="Perfil" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </ListItem>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                disablePadding
                sx={{
                  borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                  paddingLeft: "10px",
                }}
              >
                <ListItemButton
                  sx={{
                    color: theme.color.silver,
                    "&:hover": {
                      color: theme.color.honey,
                      transition: "color 0.3s ease-in-out",
                      svg: {
                        color: theme.color.honey,
                        transition: "color 0.3s ease-in-out",
                      },
                    },
                  }}
                  onClick={() => handleButtonClick(`${ROUTES.PROFILE}`)}
                >
                  <ListItemIcon>
                    <AccountCircle
                      sx={{ color: theme.color.silver, paddingLeft: "10px" }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Mi Perfil" />
                </ListItemButton>
              </ListItem>

              {variant === "admin" ? (
                null
              ) : (
                <>
                  <ListItem
                    disablePadding
                    sx={{
                      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                      paddingLeft: "10px",
                    }}
                  >
                    <ListItemButton
                      sx={{
                        color: theme.color.silver,
                        "&:hover": {
                          color: theme.color.honey,
                          transition: "color 0.3s ease-in-out",
                          svg: {
                            color: theme.color.honey,
                            transition: "color 0.3s ease-in-out",
                          },
                        },
                      }}
                      onClick={() => handleButtonClick(`${ROUTES.STATISTICS}`)}
                    >
                      <ListItemIcon>
                        <BarChart
                          sx={{ color: theme.color.silver, paddingLeft: "10px" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Mis estadísticas" />
                    </ListItemButton>
                  </ListItem>

                  <ListItem
                    disablePadding
                    sx={{
                      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                      paddingLeft: "10px",
                    }}
                  >
                    <ListItemButton
                      sx={{
                        color: theme.color.silver,
                        "&:hover": {
                          color: theme.color.honey,
                          transition: "color 0.3s ease-in-out",
                          svg: {
                            color: theme.color.honey,
                            transition: "color 0.3s ease-in-out",
                          },
                        },
                      }}
                      onClick={() => handleButtonClick(`${ROUTES.HISTORY}`)}
                    >
                      <ListItemIcon>
                        <History
                          sx={{ color: theme.color.silver, paddingLeft: "10px" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Historial" />
                    </ListItemButton>
                  </ListItem>
                </>
              )
              }

              <ListItem
                disablePadding
                sx={{
                  borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                  paddingLeft: "10px",
                }}
              >
                <ListItemButton
                  sx={{
                    color: theme.color.silver,
                    "&:hover": {
                      color: theme.color.ruby,
                      transition: "color 0.3s ease-in-out",
                      svg: {
                        color: theme.color.ruby,
                        transition: "color 0.3s ease-in-out",
                      },
                    },
                  }}
                  onClick={handleLogout}
                >
                  <ListItemIcon>
                    <Logout
                      sx={{ color: theme.color.silver, paddingLeft: "10px" }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Cerrar Sesión" />
                </ListItemButton>
              </ListItem>
            </List>
          </Collapse>
        </List>
      </Box>
    );
  };

  return (
    <>
      <HeaderContainer />
      <SecondHeaderContainer>
        <Box
          sx={{
            // backdropFilter: "blur(15px)",
            backgroundColor: "rgba(20, 35, 55)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "80px",
            fontFamily: "Inter, sans-serif",
            zIndex: 100002,
            boxShadow: "0px 1px 7px 0px #202020",
          }}
        >
          <LogoContainer onClick={() => {
            variant === "admin" ? navigate(`${ROUTES.ADMIN}${ROUTES.PANEL}`) : navigate(`${ROUTES.RESERVE}`)
            }}>
            <HeaderLogoImgContainer>
              <HeaderLogoImg src={HubReserveLogo} />
            </HeaderLogoImgContainer>
          </LogoContainer>
          <HeaderLinkContainer>
            {variant === "admin" ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <HeaderLink
                  onClick={() => navigate(`${ROUTES.ADMIN}${ROUTES.PANEL}`)}
                >
                  Panel
                </HeaderLink>
                <HeaderLink
                  onClick={() =>
                    navigate(`${ROUTES.ADMIN}${ROUTES.ADMIN_RESERVATIONS}`)
                  }
                >
                  Reservaciones
                </HeaderLink>
                <HeaderLink
                  onClick={() =>
                    navigate(`${ROUTES.ADMIN}${ROUTES.STATISTICS}`)
                  }
                >
                  Estadísticas
                </HeaderLink>
                <HeaderLink
                  onClick={() => navigate(`${ROUTES.ADMIN}${ROUTES.USERS}`)}
                >
                  Usuarios
                </HeaderLink>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                {selectedImage ? (
                  <Avatar
                    sx={{
                      width: 24,
                      height: 24,
                      margin: "0 -7px 0 7px",
                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                    onClick={handleProfileDropdownToggle}
                    src={selectedImage}
                  />
                ) : (
                  <Avatar
                    sx={{ width: 24, height: 24, margin: "0 -7px 0 7px" }}
                    onClick={handleProfileDropdownToggle}
                  >
                    {userName ? userName[0] : "U"}
                  </Avatar>
                )}

                <HeaderLink onClick={handleProfileDropdownToggle}>
                  Perfil
                </HeaderLink>
                {isProfileDropdownOpen && (
                  <ProfileDropdown
                    isAdmin={true}
                    isOpen={isProfileDropdownOpen}
                    onClose={handleProfileDropdownToggle}
                  />
                )}
                </div>
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <HeaderLink onClick={() => navigate(`${ROUTES.RESERVE}`)}>
                  Reservar
                </HeaderLink>
                <HeaderLink onClick={() => navigate(`${ROUTES.FAVORITES}`)}>
                  Favoritos
                </HeaderLink>
                <HeaderLink onClick={() => navigate(`${ROUTES.CALENDAR}`)}>
                  Calendario
                </HeaderLink>
                <HeaderLink onClick={() => navigate(`${ROUTES.RESERVATIONS}`)}>
                  Mis Reservaciones
                </HeaderLink>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  {selectedImage ? (
                    <Avatar
                      sx={{
                        width: 24,
                        height: 24,
                        margin: "0 -7px 0 7px",
                        "&:hover": {
                          cursor: "pointer",
                        },
                      }}
                      onClick={handleProfileDropdownToggle}
                      src={selectedImage}
                    />
                  ) : (
                    <Avatar
                      sx={{ width: 24, height: 24, margin: "0 -7px 0 7px" }}
                      onClick={handleProfileDropdownToggle}
                    >
                      {userName ? userName[0] : "U"}
                    </Avatar>
                  )}

                  <HeaderLink onClick={handleProfileDropdownToggle}>
                    Perfil
                  </HeaderLink>
                  {isProfileDropdownOpen && (
                    <ProfileDropdown
                      isAdmin={false}
                      isOpen={isProfileDropdownOpen}
                      onClose={handleProfileDropdownToggle}
                    />
                  )}
                </div>
              </div>
            )}
          </HeaderLinkContainer>
          <MobileMenuButton onClick={handleDrawerToggle}>
            <MenuIcon style={{ color: "#fff" }} />
          </MobileMenuButton>
        </Box>
      </SecondHeaderContainer>
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={handleDrawerToggle}
        sx={{
          "& .MuiDrawer-paper": {
            background: "#2B2A2A",
            color: "#fff",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            py: 3,
          }}
        >
          <IconButton
            onClick={handleDrawerToggle}
            sx={{
              color: "#fff",
              position: "absolute",
              top: 10,
              right: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        {list()}
      </Drawer>
    </>
  );
};

export default Header;
